export enum NOTIFICATION_VARIANTS {
  ATTENTION = 'attention',
  INFORMATIVE = 'informative',
  SUCCESS = 'success',
  ERROR = 'error',
}
